var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10C0 4.493 4.493 0 10 0s10 4.493 10 10-4.493 10-10 10S0 15.507 0 10zm1.16 0c0 4.87 3.97 8.84 8.84 8.84 4.87 0 8.84-3.97 8.84-8.84 0-4.87-3.97-8.84-8.84-8.84-4.87 0-8.84 3.97-8.84 8.84z",
    fill: "#34C38F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.942 6.696L8.348 12.29 6.058 10a.56.56 0 00-.812 0 .56.56 0 000 .812l2.696 2.695a.57.57 0 00.406.174c.145 0 .29-.058.405-.174l6-6a.56.56 0 000-.811.56.56 0 00-.811 0z",
    fill: "#34C38F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDone);
export default __webpack_public_path__ + "static/media/icon-done.c40c7374118ce2366cd66bee8e4b8896.svg";
export { ForwardRef as ReactComponent };